import React, { useState } from 'react';
import styled from 'styled-components';
import { FaBars, FaTimes } from 'react-icons/fa';
import logo from '../../assets/Logo.png';
import { navigationItems, contactInfo } from '../../config/navigation';

const Nav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  background-color: #fff;
  max-width: 1400px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    padding: 1rem 0.5rem;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const Logo = styled.img`
  height: 64px;
  width: auto;
`;

const LogoLink = styled.a`
  text-decoration: none;
  display: inline-flex;
`;

const CenterNavLinks = styled.div<{ isOpen: boolean }>`
  display: flex;
  align-items: center;
  gap: 2rem;
  flex: 2;
  justify-content: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    display: ${({ isOpen }: { isOpen: boolean }) => (isOpen ? 'flex' : 'none')};
    flex-direction: column;
    width: 100%;
    gap: 1rem;
  }
`;

const RightSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled.a<{ isActive?: boolean }>`
  text-decoration: none;
  color: #64748b;
  font-size: 1rem;
  font-weight: ${({ isActive }) => (isActive ? '700' : '500')};
  transition: color 0.2s ease;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    padding: 0.5rem 0;
    margin-left: 2rem;
    width: 100%;
    text-align: left;
  }
`;

const ContactButton = styled.a`
  color: white;
  background: linear-gradient(110.71deg, #1a3156 0%, #294e89 100%);
  padding: 0.75rem 1.5rem;
  border-radius: 5px;
  text-decoration: none;
  font-weight: 500;
  transition: background-color 0.2s ease;
`;

const HamburgerIcon = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 768px) {
    display: block;
    position: absolute;
    left: 1rem;
  }
`;

export const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const currentPath = window.location.pathname;

  const toggleNav = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Nav>
      <LogoContainer>
        <HamburgerIcon onClick={toggleNav}>{isOpen ? <FaTimes size={24} /> : <FaBars size={24} />}</HamburgerIcon>
        <LogoLink href="/">
          <Logo src={logo} alt="Company Logo" />
        </LogoLink>
      </LogoContainer>
      <CenterNavLinks isOpen={isOpen}>
        {navigationItems.map((item) => (
          <NavLink key={item.href} href={item.href} isActive={currentPath === item.href}>
            {item.label}
          </NavLink>
        ))}
      </CenterNavLinks>
      <RightSection>
        <ContactButton href={`https://wa.me/${contactInfo.phoneNumber}`} aria-label="Contact us">
          Contact Us
        </ContactButton>
      </RightSection>
    </Nav>
  );
};
